import { COUPON_TYPE_GROUP } from '@/enums/detail'

import { TicketPhoto } from '@/api/dto/ticket'

export class TicketDetailModel {
  couponSeq!: number
  couponName!: string
  couponTypeSeq!: number
  couponTypeGroup!: COUPON_TYPE_GROUP
  couponTypeName!: string
  price!: number
  isOpen!: boolean
  isSoldOut!: boolean
  usingTimeLabel!: string
  usingDateLabel!: string
  nextTimeLabel!: string
  notice!: string
  notice2!: string
  enteringNotice!: string
  photos!: TicketPhoto[]
}

export class AbleTimeModel {
  title!: string
  predictBeginTime!: string
  predictEndTime!: string
}

export const initList = [
  {
    value: '신용/체크카드',
    name: 'payment',
    id: 'nicepay',
    checked: true
  },
  {
    value: '네이버페이',
    name: 'payment',
    id: 'naverpay',
    checked: false
  },
  {
    value: '휴대폰',
    name: 'payment',
    id: 'mobilians',
    checked: false
  }
]
